import swal from "sweetalert";
import axiosInstance from "../api";
import { setGetDashboardListData, setSettingsListData } from "../reusable/reusableSlice";


export const getSettingsListAll = (data) => async (dispatch) => {
    try {
      const response = await axiosInstance.get("setting/get_data",data);
      if (response?.data) {
        dispatch(setSettingsListData(response?.data?.response))
      } else {
        dispatch(setSettingsListData([]))
      }
    } catch (err) {
      console.error(err);
      dispatch(setSettingsListData([]))
    }
  };


  export const UpdateSettingsPage = (data, setLoading) => async (dispatch) => {
    setLoading(true);
    try {
      const response = await axiosInstance.post("setting/update", data);
      if (response?.data?.status) {
        dispatch(getSettingsListAll());
        swal({
          text: response?.data?.response?.message,
          icon: "success",
          button: "Close",
          timer: 1500,
        });
        return response
      }
      else{
        swal({
          text: response?.data?.message,
          icon: "error",
          button: "Close",
          timer: 1500,
        });
      }
  
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  export const getMainDashboardData = (data) => async (dispatch) => {
    try {
      const response = await axiosInstance.post("dashboard/get_dashboard",data);
      if (response?.data) {
        dispatch(setGetDashboardListData(response?.data?.response))
      } else {
        dispatch(setGetDashboardListData([]))
      }
    } catch (err) {
      console.error(err);
      dispatch(setGetDashboardListData([]))
    }
  };
